import React from "react";
import { BmModal, Btn } from "../ui/BrandUI";

// First step of "Send contract": use the Cache standard contract or upload
// the brand's own. The choice opens ContractTermsModal in the matching mode.
const ContractChoiceModal = ({ onChoose, onClose }) => (
  <BmModal
    title="Would you like to upload your own contract?"
    onClose={onClose}
    width={560}
    footer={
      <>
        <Btn variant="secondary" className="flex-1" onClick={() => onChoose("custom")}>
          Upload my own contract
        </Btn>
        <Btn className="flex-1" onClick={() => onChoose("standard")}>
          Use Cache standard contract
        </Btn>
      </>
    }
  >
    <div className="rounded-[8px] border border-bm-border bg-bm-subtle px-4 py-[14px] bm-body-m text-bm-muted">
      Cache can provide a standard contract if you don't have your own custom contract
    </div>
  </BmModal>
);

export default ContractChoiceModal;
